import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorMessage, Field } from "formik";
import Link from "next/link";
import { Routes } from "~/constants/routes";
import { SIGN_UP_TERMS_INPUT } from "~/constants/testIDs";
/**
 * MailChimp is requiring us to add this to our sign up flow in order to send
 * out marketing campaign. You'll notice that this isn't using any existing component
 * and everything is inline. This is a quick temporary solution until we have a
 * proper checkbox component that lives within Zephyr. (Sorry Kyle)
 */ export const TermsCheckbox = ()=>{
    return /*#__PURE__*/ _jsxs("label", {
        className: "mb-6 mt-12 flex text-12 text-pigeon-500",
        htmlFor: "terms",
        "data-testid": SIGN_UP_TERMS_INPUT,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mr-2 mt-1 shrink-0",
                children: /*#__PURE__*/ _jsx(Field, {
                    id: "terms",
                    type: "checkbox",
                    name: "terms",
                    required: true
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    "By checking this box, you agree to Air's ",
                    /*#__PURE__*/ _jsx(Link, {
                        href: Routes.marketing.terms,
                        children: "Terms of Service"
                    }),
                    " ,",
                    " ",
                    /*#__PURE__*/ _jsx(Link, {
                        href: Routes.marketing.privacy,
                        children: "Privacy Policy"
                    }),
                    ", and occasional emails regarding product and service updates. You can unsubscribe at any time.",
                    /*#__PURE__*/ _jsx(ErrorMessage, {
                        name: "terms",
                        children: (msg)=>/*#__PURE__*/ _jsx("div", {
                                className: "text-12 text-flamingo-600",
                                children: msg
                            })
                    })
                ]
            })
        ]
    });
};
